import axios from 'axios';
import {token} from '../apis/TokenBasedLoginAPI';
import {serializeDate, formatSorting} from '../utility/ApiParamConversion';

export const bootAPI = (onUnauthorizedForbidden: () => void) => {
    axios.interceptors.response.use(undefined, (error) => {
        if (error.status === 401 || error.status === 403) {
            onUnauthorizedForbidden();
        }
        return Promise.reject(error);
    });

    axios.interceptors.request.use(async (config) => {
        token().then((authToken) => (config.headers.Authorization = `Bearer ${authToken}`));

        if (config.params) {
            config.params = reformatParamsForBackend(config.params);
        }

        return config;
    });

    const reformatParamsForBackend = (params: any) => {
        return formatSorting(serializeDate(params));
    };
};



// WEBPACK FOOTER //
// ./src/boot/api.ts